/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import {
	ControlBar,
	AudioInputControl,
	VideoInputControl,
	ContentShareControl,
	AudioOutputControl,
	useContentShareState,
} from "amazon-chime-sdk-component-library-react";
import "./styles.scss";
import EndMeetingControl from "../EndMeetingControl";

const MeetingControls = () => {
	const { isLocalUserSharing, isLocalShareLoading } = useContentShareState();
	return (
		<div className="pace-meeting-controls">
			<ControlBar className="controls-menu" layout="undocked-horizontal" showLabels>
				<>
					<AudioInputControl className="control-button" />
					{!(isLocalShareLoading || isLocalUserSharing) && <VideoInputControl className="control-button" />}
					<ContentShareControl className="control-button" />
					<AudioOutputControl className="control-button" />
					<EndMeetingControl className="control-button" />
				</>
			</ControlBar>
		</div>
	);
};

export default MeetingControls;
